import React, { useState } from "react";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

const BeautifiedCodeViewer = ({ code }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        try {
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(code);
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = code;
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }

            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error("Copy failed:", err);
        }
    };

    return (
        <div className="relative p-4 bg-white rounded-md overflow-x-auto border border-gray-200 text-xs">
            <button
                onClick={handleCopy}
                className="absolute top-2 right-2 px-2 py-1 text-sm bg-gray-200 hover:bg-gray-300 rounded text-gray-700"
            >
                {copied ? "Copied!" : "Copy"}
            </button>

            <SyntaxHighlighter language={null} style={docco} showLineNumbers>
                {code}
            </SyntaxHighlighter>
        </div>
    );
};

export default BeautifiedCodeViewer;
